import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "button"]

  connect() {
    // Add click outside listener when controller connects
    this.boundClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.boundClickOutside)
  }

  disconnect() {
    // Clean up event listener when controller disconnects
    document.removeEventListener('click', this.boundClickOutside)
  }

  toggle() {
    this.dropdownTarget.classList.toggle('hidden')
  }

  closeDropdown() {
    this.dropdownTarget.classList.add('hidden')
  }

  handleClickOutside(event) {
    // Close dropdown if clicking outside
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add('hidden')
    }
  }
} 